<template>
  <div id="apply">
    <div class="container">
      <step-1 v-show="step == 1" />
      <step-2 v-show="step == 2" @confirm="handleConfirmOpen" />
      <step-3 v-show="step == 3" @confirm="handleConfirmOpen" />
      <step-4 v-show="step == 4" @confirm="handleConfirmOpen" />
      <step-5 v-show="step == 5" @confirm="handleConfirmOpen" />

      <Prompt ref="prompt"></Prompt>
      <ui-modal-confirm ref="exit" :options="comfirmOptions" @apply="handleApply" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import * as api from '@/service/index'
import Step1 from './step1.vue'
import Step2 from './step2.vue'
import Step3 from './step3.vue'
import Step4 from './step4.vue'
import Step5 from './step5.vue'
import Prompt from '@/components/prompt'
import UiModalConfirm from '@/components/ui-modal-confirm'

export default {
  components: { Step1, Step2, Step3, Step4, Step5, Prompt, UiModalConfirm },
  provide() {
    return {
      reqApplyInfo: this.reqApplyInfo,
      handleStep: this.handleStep,
      handleStepSubmit: this.handleStepSubmit,
      promptMsg: this.promptMsg,
      apply_info: () => this.apply_info,
      updateInfo: this.updateInfo,

      is_apply: false,
      // uid: 'gongjiali',
      // nick: 'test',
      info_player: () => this.temp_player_list,
      filter_: 1,
      pass_: 0
    }
  },
  data() {
    return {
      step: 1,

      apply_info: {},
      submit_info: {},

      temp_player_list: [],
      loading: false,
      comfirmOptions: {
        tip: '报名尚未完成，是否退出当前页面'
      }
    }
  },
  computed: {
    ...mapState(['token'])
  },
  mounted() {
    this.reqApplyInfo()
  },
  methods: {
    ...mapMutations(['SET_NAVSTATUS']),
    reqApplyInfo() {
      if (!this.token) {
        this.promptMsg('未检测到token')
        return
      }

      api
        .reqApplyInfo({
          token: this.token
        })
        .then((r) => {
          if (r.status == 200) {
            this.apply_info = r.data
            // 显示进度的队员列表
            this.getTempPlayerList(r.data)
          } else {
            this.promptMsg(r.data)
          }
        })
    },
    getTempPlayerList(data) {
      let list = []
      list.push({
        uid: data.uid,
        nick: data.nick,
        label: '队长'
      })
      let player = data.player || []
      if (player.lengh != 0) {
        player.forEach((item) => {
          list.push({
            uid: item.uid,
            nick: item.nick,
            label: item.player_type == 1 ? '队员' : '替补'
          })
        })
      }

      this.temp_player_list = list
    },
    handleStep(step) {
      this.step = step

      // 触发导航栏的 二级导航
      if (step >= 2) {
        let obj = {
          level: 2,
          name: '报名',
          backFn: () => {
            this.step = 1
            let obj_back = { level: 1, name: '' }
            this.SET_NAVSTATUS(obj_back)
          }
        }
        this.SET_NAVSTATUS(obj)
      }
    },
    tidyPlayerInfo(data) {
      this.temp_player_list = data

      let obj = {
        nick: '',
        contact: '',
        address: '',
        player: []
      }
      data.forEach((item) => {
        if (item.position == 'leader') {
          obj.nick = item.nick
          obj.contact = item.contact
          obj.address = item.address
        } else {
          let type = 1
          switch (item.position) {
            case 'player':
              type = 1
              break
            case 'substitute':
              type = 2
              break
          }

          obj.player.push({
            player_type: type,
            uid: String(item.uid),
            address: item.address,
            nick: item.nick
          })
        }
      })

      return obj
    },
    tidyQuestionInfo(data) {
      let obj = {
        question: []
      }

      data.forEach((item) => {
        obj.question.push({
          question_id: String(item.id),
          answer: Number(item.state)
        })
      })

      return obj
    },
    tidyTeamInfo(data) {
      let obj = {
        team_name: data.name,
        team_intro: data.intro,
        team_desc: data.player_intro
      }

      return obj
    },
    handleStepSubmit(step, data) {
      switch (step) {
        case 2:
          let p = this.tidyPlayerInfo(data)
          this.submit_info = { ...this.submit_info, ...p }
          break
        case 3:
          let q = this.tidyQuestionInfo(data)
          this.submit_info = { ...this.submit_info, ...q }
          break
        case 4:
          let t = this.tidyTeamInfo(data)
          this.submit_info = { ...this.submit_info, ...t }
          // 提交所有报名信息
          this.submit()
          break
      }
    },
    submit() {
      if (this.loading) return

      if(!this.token) return;
      this.loading = true
      api.submit(this.token, this.submit_info).then((r) => {
        if (r.status == 200 && r.data.success) {
          this.handleStep(5)
          // 报名完成后，更新报名信息
          this.reqApplyInfo()
        } else {
          this.promptMsg(r.data)
        }

        this.loading = false
      })
    },
    promptMsg(msg) {
      this.$refs.prompt.setMsg(msg)
    },
    updateInfo(key, val) {
      this.apply_info[key] = val
    },
    handleConfirmOpen() {
      this.$refs.exit.showModal()
    },
    handleApply() {
      this.handleStep(1)
    }
  }
}
</script>

<style lang="scss">
#apply {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  // height: get_percentage(710px);
  height: 100%;
  width: 100%;
  .container {
    position: relative;
    width: 100%;
    margin: 0 get_vh(16px) 0;
    border-radius: get_vh(20px);
    // height: get_vh(622px);

    .role,
    .role1 {
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      position: absolute;
    }
    .role {
      width: get_vh(216px);
      height: get_vh(500px);
      background-image: url('https://website.xdcdn.net/poster/355916/sausage-match/9Lq0PsYq.png');
      left: get_vh(70px);
      bottom: 0;
    }
    .role1 {
      width: get_vh(300px);
      height: get_vh(500px);
      background-image: url('https://website.xdcdn.net/poster/355916/sausage-match/9Lq0PefF.png');
      right: 0;
      bottom: 0;
    }
  }
}

.ui-box-apply {
  margin: 0 auto;
  width: 100%;
  height: get_vh(710px) !important;
}
</style>